const translations = {
  "en": {
    "Show less plans": "Show less plans",
    "Show more plans": "Show more plans"
  },
  "zh-tw": {
    "Show less plans": "顯示較少方案",
    "Show more plans": "顯示更多方案"
  }
};

export default translations;
